const schType = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.សាលារៀនចំណេះទូទៅ' },
  { value: 2, text: '២.សាលារៀនជំនាន់ថ្មី' }, { value: 3, text: '៣.សាលារៀនអប់រំពិសេស' }
]
const schCFS = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.កម្រិតមូលដ្ឋាន' }, { value: 2, text: '២.កម្រិតមធ្យម' },
  { value: 3, text: '៣.កម្រិតអភិវឌ្ឍន៍' }, { value: 4, text: '៤.មិនមានការកំណត់' }
]
const schNUF = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.ពិតមែន' }, { value: 2, text: '២.ទេ' }
]
const schNUS = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.រដ្ឋាភិបាល' }, { value: 2, text: '២.កម្មវិធីស្បៀងអាហារពិភពលោក' },
  { value: 3, text: '៣.ផ្សេងៗ' }
]
const coreSat = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.បង្គោល' }, { value: 2, text: '២.សម្ព័ន្ធ' }
]
const priAge = ['៧០-៧១ខែ', '៦', '៧', '៨', '៩', '១០', '១១', '១២', '១៣', '១៤', '១៥+']
const priMig = ['សរុប']
const priLevel = ['ថ្នាក់ទី ១', 'ថ្នាក់ទី ២', 'ថ្នាក់ទី ៣', 'ថ្នាក់ទី ៤', 'ថ្នាក់ទី ៥', 'ថ្នាក់ទី ៦', 'សរុបរួម (ពីថ្នាក់ទី ១ ដល់ទី ៦)']
const c2 = ['សិស្ស (អាយុ ៧០-៧១ខែ និង៦)', 'សិស្ស (អាយុ ៦-១១)', 'សិស្ស (អាយុ ១២+)', 'គ្រូបង្រៀន (ជនជាតិដើមភាគតិច)',
  'គ្រូមិនបង្រៀន (ជនជាតិដើមភាគតិច)','ចំនួនសិស្សរៀន​ ពហុភាសា']
const d2 = ['ដើមឆ្នាំសិក្សា', 'ចុងឆ្នាំសិក្សា', 'ត្រូវបានឡើងថ្នាក់', 'ត្រូវបានឆ្លងភូមិសិក្សា', 'សិស្សផ្ទេរមកពីសាលារៀនផ្សេង',
  'សិស្សផ្ទេរចេញទៅសាលារៀនផ្សេង', 'សិស្សមកពីសាលារៀនផ្សេងដែលមិនមានគ្រប់កម្រិតថ្នាក់', 'សិស្សអាហារូបករណ៍ឆ្នាំសិក្សាថ្មី']
  
const e2 = ['ចំនួនសិស្សបានចូលរៀនឡើងវិញ', 'ចំនួនសិស្សក្នុងកម្មវិធីសមមូល', 'ចំនួនសិស្សក្នុងកម្មវិធីពន្លឿន']
const f2 = ['មត្តេយ្យរដ្ឋ', 'មត្តេយ្យឯកជន', 'មត្តេយ្យសហគមន៍', 'ការអប់រំតាមផ្ទះ/តាមខ្នងផ្ទះ', 'កម្មវិធីត្រៀមថ្នាក់ទី១']
const g2 = [{ value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: 'ទី១' },
{ value: 2, text: 'ទី២' }, { value: 3, text: 'ទី៣' }]
const b4 = ['លេខាធិការ', 'បណ្ណារក្ស (បណ្ណាល័យស្ដង់ដា)', 'គ្រូទទួលបន្ទុកកីឡា', 'គ្រូទទួលបន្ទុកបច្ចេកវិទ្យាព័ត៌មានវិទ្យា ICT',
  'គ្រូទទួលបន្ទុកគណនេយ្យ និងបេឡា', 'គ្រូទទួលបន្ទុកបន្ទប់ពិសោធន៍', 'គ្រូទទួលបន្ទុកការងារយុវជន', 'គ្រូបង្រៀនអប់រំបំណិនជីវិត',
  'គ្រូទទួលបន្ទុកការងារសុខភាពសិក្សា', 'សរុប']
const d4 = ['បុគ្គលិកក្របខ័ណ្ឌ', 'គ្រូបង្រៀនថ្នាក់គួប', 'គ្រូជាប់កិច្ចសន្យា', 'បុគ្គលិកពិការភាព',
  'បុគ្គលិកបង្រៀនដែលមានវិធីសាស្ត្រដាក់ពិន័យសិស្សតាមបែបវិជ្ជមាន',
  'គ្រូបង្រៀនថ្នាក់ពហុភាសា(ភាសាជនជាតិភាគតិច)',
  'ចំនួនគ្រូបង្រៀន (STEM) ផ្នែកវិទ្យាសាស្រ្តពិត',
  'ចំនួនគ្រូបង្រៀន (STEM) ផ្នែកវិទ្យាសាស្រ្តសង្គម'
]
const lstStuOnOff = [
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]
]
const ethpriOnOff = [
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]
]
const stupriOnOff1 = [
  [1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
]
const stupriOnOff2 = [
  [0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0],
  [1, 1, 0, 0, 0, 0, 0, 0],
  [1, 1, 1, 1, 1, 1, 0, 0],
  [1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1]
]
/** Configuration of UI Page Text */
const priUIText = [
  ['១. អត្តសញ្ញាណ <p><br>និងព័ត៌មានសាវតា</p>', '១.(ក) នាយក/នាយិកាសាលាបឋមសិក្សា (មិនមែននាយកកម្រង)', '១.(ខ) សាលាបឋមសិក្សា', '១.(គ) អ្នកទទួលបន្ទុកគ្រប់គ្រងសាលារៀនឧបសម្ព័ន្ធ'],
  ['២. សិស្ស', 
    '<b>២.(ក១) កុមារមត្តេយ្យសិក្សាតាមអាយុ និងតាមកម្រិតថ្នាក់ឆ្នាំសិក្សា</b>', '<b>២.(ក២) សិស្សថ្មី សិស្សឡើងថ្នាក់ និងសិស្សត្រួតថ្នាក់ក្នុងឆ្នាំសិក្សា</b>',
    '២. (ខ១) សិស្សពិការ សិស្សជួបការលំបាកផ្នែកសុខភាព និងសិស្សជួបការលំបាកតាមកម្រិតថ្នាក់(មត្តេយ្យសិក្សា)', '២. (ខ២) សិស្សពិការ សិស្សជួបការលំបាកផ្នែកសុខភាព និងសិស្សជួបការលំបាកតាមកម្រិតថ្នាក់(បឋមសិក្សា)',
    '២. (គ១) កុមារតាមអាយុ (ជនជាតិដើមភាគតិច)', '២. (គ២) សិស្សតាមក្រុមអាយុ និងគ្រូ (ជនជាតិដើមភាគតិច) (ចំនួនសិស្សជនជាតិភាគតិច ក្នុងចំណោមសិស្សសរុបទាំងអស់ នៃតារាង ២.(ក២))',
    '២. (គ៣) កុមារមត្តេយ្យសិក្សា តាមកម្រិតថ្នាក់ ឆ្នាំសិក្សា', '២. (គ៤) សិស្សបឋមសិក្សា តាមកម្រិតថ្នាក់ ឆ្នាំសិក្សា',
    '២. (ឃ១) ចំនួនកុមាររៀនក្នុងឆ្នាំសិក្សា', '២. (ឃ២) ចំនួនសិស្ស និងលទ្ធផលប្រឡង ក្នុងឆ្នាំសិក្សា ',
    '២. (ង) ចំនួនសិស្សចូលរៀនឡើងវិញ (សិស្សដែលបានបោះបង់ការសិក្សាហើយបានចូលរៀនវិញ)', 
    '២. (ច) សិស្សថ្នាក់ទី១ បានឆ្លងកម្មវិធីកុមារតូច', '២.(ឆ) ចំនួនសិស្សថ្នាក់គួប តាមវេន (ក្នុងមួយជួរដេកត្រូវបំពេញតែ១ថ្នាក់គួប)','២. (ជ) លទ្ធផលសិក្សា របស់សិស្សក្នុងឆ្នាំសិក្សា '
  ],
  ['៣. បន្ទប់រៀន <p><br>និងថ្នាក់រៀន</p>',
     '៣. (ក) បន្ទប់រៀន', '៣. (ខ១) ចំនួនថ្នាក់រៀនមត្តេយ្យសិក្សា', '៣. (ខ២) ចំនួនថ្នាក់រៀនបឋមសិក្សា', '៣. (ឃ) ល្បែង និងសម្ភារសិក្សា', '៣. (គ) ចំនួនគ្រូបង្រៀន និងគ្រូកិច្ចព្រមព្រៀងការងារ តាមកម្រិតថ្នាក់'
  ],
  ['៤. បុគ្គលិកបង្រៀន <p><br>និងបុគ្គលិកមិនបង្រៀន</p>', '៤. (ក) ចំនួនបុគ្គលិកអប់រំតាមប្រភេទក្របខ័ណ្ឌ(សណន លេខ ២៥៦)', '៤. (ខ) ចំនួនបុគ្គលិកបង្រៀន/មិនបង្រៀនក្របខ័ណ្ឌទទួលមុខងារបន្ថែម', '៤. (គ) ចំនួនបុគ្គលិកបង្រៀន២វេន និងបង្រៀនថ្នាក់គួប',
    '៤.(ឃ) បុគ្គលិកបង្រៀនផ្សេងៗ ដែលបានទទួលការបណ្ដុះបណ្ដាល និងមិនបានទទួលការបណ្តុះបណ្តាល', '៤. (ង) កម្រិតវប្បធម៌របស់បុគ្គលិកក្របខ័ណ្ឌ និងវគ្គបណ្ដុះបណ្ដាលគរុកោសល្យ'],
  ['៥. អគារ និងបរិក្ខារ', '៥.(ក) ផ្ទៃដីសាលារៀន', '៥.(ខ) អំពីសំណង់', '៥.(គ) ស្ថានភាពអគារ បន្ទប់ និងបរិក្ខារ',
    '៥(ឃ).កន្លែងលាងដៃ', '៥.(ង) បង្គន់អនាម័យ (គិតជាបន្ទប់)', '៥.(ច).ប្រភពទឹកសម្រាប់ប្រើប្រាស់',
    '៥(ឆ).សម្ភារបរិក្ខា', '៥.(ជ) សម្ភារកីឡា',
    '៥. អគារ និងបរិក្ខារ', '៥.(ក) ស្ថានភាពអគារ បន្ទប់ និងបរិក្ខារ', '៥.(ខ) ចំនួនបរិក្ខារ', '៥.(គ) ផ្ទៃដីសាលារៀន',
    '៥(ឃ) កន្លែងលាងដៃ', '៥.(ង) បង្គន់អនាម័យ (គិតជាបន្ទប់)', '៥.(ច) ប្រភពទឹកសម្រាប់ប្រើប្រាស់',
    '៥(ឆ).សម្ភារបរិក្ខារ', '៥.(ជ) ខ្សែសេវា អ៊ីនធើណេតសម្រាប់សាលារៀន', '៥.(ញ) សម្ភារកីឡា',
    '៥.(ដ) អគារអន្តេវាសិកដ្ឋាន (សម្រាប់បុគ្គលិកអប់រំ និងសិស្ស)',
    '៥.(ឋ) អគារអ៊ីនធឺណិតសហគមន៍ ដែលស្ថិតក្នុងបរិវេនសាលារៀន'
  ],

  ['៦. ការចូលរួមរបស់សហគមន៍', '៦. (ក) គណៈកម្មការគ្រប់គ្រងសាលារៀន', '៦. (ខ) ហិរញ្ញប្បទានក្នុងឆ្នាំ'],
  ['៧. ការចែកចាយថ្នាំព្រូន', '៧. ការចែកចាយថ្នាំព្រូនក្នុងឆ្នាំសិក្សា'],
  ['៨. ស្ថានភាពទឹកស្អាត និង<p><br>អនាម័យតាមសាលារៀន'],
  [
    '៩. ទិន្នន័យស្តីអំពីការបម្រែ<p><br>បម្រួលអាកាសធាតុ',
    '១.ចំនួនសិស្សមានបញ្ហាសុខភាព ដែលពាក់ព័ន្ធព្រឹត្តិការណ៍នៃគ្រោះមហន្តរាយធម្មជាតិ ក្នុងឆ្នាំសិក្សា',
    '២.ប្រអប់សង្រ្គោះបឋមរបស់សាលារៀន',
    '៣.មូលហេតុបិទសាលារៀន និងចំនួនថ្ងៃបិទសាលារៀនដែលមិនបានគ្រោងទុក',
    '៤.ហេដ្ឋារចនាសម្ព័ន្ធសាលារៀនដែលត្រូវខូចខាត ឬបាត់បង់ដោយសារគ្រោះធម្មជាតិ',
    '៥.ការគ្រប់គ្រងគ្រោះមហន្តរាយ និងផែនការកាត់បន្ថយហានិភ័យ',
    '៦.ចំនួនបន្ទប់រៀនដែលមានកង្ហារ ឬម៉ាស៊ីនត្រជាក់',
    '៧.ចំនួនថ្ងៃដែលសាលារៀនជួប្រទះនឹង៖ ការខ្វះអគ្គីសនី ការខ្វះទឹកស្អាត និងបង្គន់ប្រើប្រាស់មិនកើត ដោយសារគ្រោះមហន្តរាយ',
    '៨.ចំនួនសិស្សដែលអវត្តមានក្នុងឆ្នាំសិក្សា ពី២០ថ្ងៃដល់៤០ថ្ងៃ និងលើស៤០ថ្ងៃ (កុំរាប់សិស្សពីរដង)៖',
    '៩.ការរៀនសូត្រជម្រើសផ្សេងទៀត (Alternative Education) ក្នុងពេលដែលសាលារៀនត្រូវបិទ',
    '១០.ចំនួនសម្ភារសិក្សាដែលត្រូវបានខូចខាត ឬត្រូវបានបំផ្លាញ ដោយសារគ្រោះមហន្តរាយ (សៀវភៅគ្រូ និងសៀវភៅសិស្ស)',
    '១១.ការគ្រប់គ្រងកាកសំណល់នៅសាលារៀន',
    '១២.ហិរញ្ញប្បទានរបស់សាលារៀន (សម្រាប់ផលប៉ះពាល់ដោយសារបម្រែបម្រួលអាកាសធាតុ)'
  ]
]
export {
  schType, schCFS, coreSat,
  priAge, priMig, priLevel, c2, d2, e2, f2, g2,
  b4, d4,
  lstStuOnOff, ethpriOnOff,
  stupriOnOff1, stupriOnOff2,
  priUIText,
  schNUF, schNUS
}
